const Country = [
  { name: "India", code: "India" },
  { name: "United States", code: "United States" },
  { name: "Algeria", code: "Algeria" },
  { name: "Afghanistan", code: "Afghanistan" },
  { name: "Albania", code: "Albania" },
  { name: "Andorra", code: "Andorra" },
  { name: "Angola", code: "Angola" },
  {
    name: "Antigua and Barbuda",
    code: "Antigua and Barbuda",
  },
  { name: "Argentina", code: "Argentina" },
  { name: "Armenia", code: "Armenia" },
  { name: "Australia", code: "Australia" },
  { name: "Austria", code: "Austria" },
  { name: "Azerbaijan", code: "Azerbaijan" },
  { name: "Bahamas", code: "Bahamas" },
  { name: "Bahrain", code: "Bahrain" },
  { name: "Bangladesh", code: "Bangladesh" },
  { name: "Barbados", code: "Barbados" },
  { name: "Belarus", code: "Belarus" },
  { name: "Belgium", code: "Belgium" },
  { name: "Belize", code: "Belize" },
  { name: "Benin", code: "Benin" },
  { name: "Bhutan", code: "Bhutan" },
  { name: "Bolivia", code: "Bolivia" },
  {
    name: "Bosnia and Herzegovina",
    code: "Bosnia and Herzegovina",
  },
  { name: "Botswana", code: "Botswana" },
  { name: "Brazil", code: "Brazil" },
  { name: "Brunei", code: "Brunei" },
  { name: "Bulgaria", code: "Bulgaria" },
  { name: "Burkina Faso", code: "Burkina Faso" },
  { name: "Burundi", code: "Burundi" },
  { name: "Cabo Verde", code: "Cabo Verde" },
  { name: "Cambodia", code: "Cambodia" },
  { name: "Cameroon", code: "Cameroon" },
  { name: "Canada", code: "Canada" },
  {
    name: "Central African Republic",
    code: "Central African Republic",
  },
  { name: "Chad", code: "Chad" },
  { name: "Chile", code: "Chile" },
  { name: "China", code: "China" },
  { name: "Colombia", code: "Colombia" },
  { name: "Comoros", code: "Comoros" },
  {
    name: "Congo, Democratic Republic of the",
    code: "Congo, Democratic Republic of the",
  },
  {
    name: "Congo, Republic of the",
    code: "Congo, Republic of the",
  },
  { name: "Costa Rica", code: "Costa Rica" },
  { name: "Croatia", code: "Croatia" },
  { name: "Cuba", code: "Cuba" },
  { name: "Cyprus", code: "Cyprus" },
  { name: "Czech Republic", code: "Czech Republic" },
  { name: "Denmark", code: "Denmark" },
  { name: "Djibouti", code: "Djibouti" },
  { name: "Dominica", code: "Dominica" },
  {
    name: "Dominican Republic",
    code: "Dominican Republic",
  },
  { name: "Ecuador", code: "Ecuador" },
  { name: "Egypt", code: "Egypt" },
  { name: "El Salvador", code: "El Salvador" },
  { name: "Equatorial Guinea", code: "Equatorial Guinea" },
  { name: "Eritrea", code: "Eritrea" },
  { name: "Estonia", code: "Estonia" },
  { name: "Eswatini", code: "Eswatini" },
  { name: "Ethiopia", code: "Ethiopia" },
  { name: "Fiji", code: "Fiji" },
  { name: "Finland", code: "Finland" },
  { name: "France", code: "France" },
  { name: "Gabon", code: "Gabon" },
  { name: "Gambia", code: "Gambia" },
  { name: "Georgia", code: "Georgia" },
  { name: "Germany", code: "Germany" },
  { name: "Ghana", code: "Ghana" },
  { name: "Greece", code: "Greece" },
  { name: "Grenada", code: "Grenada" },
  { name: "Guatemala", code: "Guatemala" },
  { name: "Guinea", code: "Guinea" },
  { name: "Guinea-Bissau", code: "Guinea-Bissau" },
  { name: "Guyana", code: "Guyana" },
  { name: "Haiti", code: "Haiti" },
  { name: "Honduras", code: "Honduras" },
  { name: "Hungary", code: "Hungary" },
  { name: "Iceland", code: "Iceland" },
  { name: "Indonesia", code: "Indonesia" },
  { name: "Iran", code: "Iran" },
  { name: "Iraq", code: "Iraq" },
  { name: "Ireland", code: "Ireland" },
  { name: "Israel", code: "Israel" },
  { name: "Italy", code: "Italy" },
  { name: "Ivory Coast", code: "Ivory Coast" },
  { name: "Jamaica", code: "Jamaica" },
  { name: "Japan", code: "Japan" },
  { name: "Jordan", code: "Jordan" },
  { name: "Kazakhstan", code: "Kazakhstan" },
  { name: "Kenya", code: "Kenya" },
  { name: "Kiribati", code: "Kiribati" },
  { name: "Kuwait", code: "Kuwait" },
  { name: "Kyrgyzstan", code: "Kyrgyzstan" },
  { name: "Laos", code: "Laos" },
  { name: "Latvia", code: "Latvia" },
  { name: "Lebanon", code: "Lebanon" },
  { name: "Lesotho", code: "Lesotho" },
  { name: "Liberia", code: "Liberia" },
  { name: "Libya", code: "Libya" },
  { name: "Liechtenstein", code: "Liechtenstein" },
  { name: "Lithuania", code: "Lithuania" },
  { name: "Luxembourg", code: "Luxembourg" },
]

export default Country
